/**
 * LogView — S2-4 full unfiltered log at the `/log` route.
 *
 * Pass-through wrapper around `TeamLogStream` with `viewMode="log"` and
 * no predicate filtering. All tags visible, all posts shown. This is
 * the audit / debug view — the chat window is the default.
 */

import { forwardRef, type ComponentProps } from "react";
import { TeamLogStream, type TeamLogStreamHandle } from "./TeamLogStream";

type StreamProps = ComponentProps<typeof TeamLogStream>;

export const LogView = forwardRef<TeamLogStreamHandle, Omit<StreamProps, "viewMode">>(
  function LogView(props, ref) {
    return <TeamLogStream {...props} ref={ref} viewMode="log" />;
  },
);
